import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Landing from './pages/Landing';
import PERMLookup from './pages/PERMLookup';
import Wizard from './pages/Wizard';
import './styles/globals.css';

function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/perm-lookup" element={<PERMLookup />} />
        <Route path="/start" element={<Wizard />} />
      </Routes>
    </Router>
  );
}

export default App;